import React from 'react'
import './Brmain.css'
import newregi from "../../imgs/newregi.png";
import password from "../../imgs/password.png";
import mediator from "../../imgs/mediator.png";
import feedback3d from "../../imgs/feedback3d.png";
import calling3d from "../../imgs/calling3d.png";
import { useNavigate } from 'react-router-dom';

const Brmain = () => {
    const navigate = useNavigate();

    const opennewregi = () => {
        navigate("/newregi");
    }

    const openprlist = () => {
        navigate("/prlist");
    }

    const openfeedback = () => {
        navigate("/feedback");
    }

    const openmadh = () => {
        navigate("/madh");
    }

    const brlogout = () => {
        localStorage.setItem("brno", "");
        localStorage.setItem("message", "");
        localStorage.setItem("inid", "");
        localStorage.setItem("atoken", "");
        localStorage.setItem("bname", "");

        navigate("/customer");

    }
    return (
        <div className='Brmain'>
            <div className="Brmainback">
                <div className="firstrow">
                    <span className='regularbold'>शाखा पॅनल - {localStorage.getItem("bname")}</span>
                    <span onClick={brlogout} className='logout'>Logout</span>
                </div>
                <div className="brmenu">
                    <div className="namerowbr">
                        <div onClick={opennewregi} className="cardbr">
                            <span className='regularbold'>New Registration</span>
                            <img className='logo' src={newregi} alt="" />
                            <div className="redbutton">
                                <span className='regularbold'>Continue</span>
                            </div>
                        </div>
                        <div onClick={openprlist} className="cardbr">
                            <span className='regularbold'>My Profiles</span>
                            <img className='logo' src={password} alt="" />
                            <div className="redbutton">
                                <span className='regularbold'>Continue</span>
                            </div>
                        </div>


                    </div>

                    <div className="namerowbr">
                        <div onClick={openmadh} className="cardbr">
                            <span className='regularbold'>Madhyasti Department</span>
                            <img className='logo' src={mediator} alt="" />
                            <div className="redbutton">
                                <span className='regularbold'>Continue</span>
                            </div>
                        </div>
                        <div onClick={openfeedback} className="cardbr">
                            <span className='regularbold'>Feedback Department</span>
                            <img className='logo' src={feedback3d} alt="" />
                            <div className="redbutton">
                                <span className='regularbold'>Continue</span>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </div>
    )
}

export default Brmain
